// Clipboard copy with an execCommand fallback: navigator.clipboard only
// exists in secure contexts (https / localhost), so plain-HTTP dev
// setups and the test grid fall back to a hidden textarea. Shared by
// clipboard_controller and any controller composing copy behavior.
export async function copyText(text: string): Promise<void> {
  if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text)
      return
    } catch {
      // fall through to the execCommand path
    }
  }

  const helper = document.createElement("textarea")
  helper.value = text
  helper.setAttribute("readonly", "")
  helper.style.position = "absolute"
  helper.style.left = "-9999px"
  document.body.appendChild(helper)
  helper.select()
  document.execCommand("copy")
  helper.remove()
}
